import React from 'react';
import { Row, Col } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './PaymentMethods.module.less';

const PaymentMethods = ({ ecmContent }) => {
  const { jsonObject } = ecmContent;
  const { title, images, primaryImage } = jsonObject;
  return (
    <div className={`${styles.payments_container}`}>
      <div className={`${styles.payment_title}`}>{title}</div>

      <div className={`${styles.primary_image}`}>
        {primaryImage ? <img src={primaryImage} alt="" /> : null}
      </div>
      <Row className={`${styles.payment_image_container}`}>
        {images.map((image, index) => (
          <Col key={index}>
            {image.image_url ? <img src={image.image_url} alt="" /> : null}
            <div className={`${styles.payment_subheader}`}>{image.sub_header}</div>
            <div className={`${styles.payment_subtext}`}>{image.sub_text}</div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

PaymentMethods.propTypes = {
  ecmContent: PropTypes.object
};
PaymentMethods.defaultProps = {
  ecmContent: { jsonObject: { title: '', images: [] } }
};

export default PaymentMethods;
